import { Box, Center } from '@chakra-ui/react';
import { useAccountContext } from '@src/components/sco/Account/Layout/AccountContext';
import { AccountMainPanel } from '@src/components/sco/Account/Layout/AccountMainPanel';
import { UserSubscriptionList } from '@src/components/sco/Account/UserSubscriptionList';
import { useActiveContentContext } from '@src/contexts/ActiveContentContext';
import { useUniversalEffect } from '@src/hooks/useUniversalEffect';
import { AccountPage } from '@src/layouts/AccountPageLayout';
import React from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default AccountPage(function () {
  const accountContext = useAccountContext();
  const activeContent = useActiveContentContext();
  useUniversalEffect(() => {
    activeContent.setSiteSection('account.billing');
  });
  useUniversalEffect(() => {
    activeContent.setBreadcrumbs([{
      title: 'Account',
      href: '/account'
    }, {
      title: 'Billing',
      href: '/account/billing'
    }]);
  }, []);
  return <AccountMainPanel>
      <Center minHeight={'80vh'} padding={'1em'}>
        <Box maxWidth={'960px'} width={'full'}>
          <UserSubscriptionList />
        </Box>
      </Center>
    </AccountMainPanel>;
});